import React, { useState } from 'react'
import { PanelBarGLPure, GridSelectionHLPure, ButtonAddHLPure, DialogSystemGLPure } from '../../pures';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const DocumentPanelBarVersions = (props) => {

    let {
        versions,
        handleSelectVersion,
        handleDeleteFileVersion,
        showVersionsBtns,
        handleMakeVersionMainDoc,
        isInDeleteFlow
    } = props

    const { t } = useTranslation()

    const headerColumnOne = (props) => {
        return <span className='documentPanelBarVersions-header-cell-one'>{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className='documentPanelBarVersions-header-cell-two'>{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className={`documentPanelBarVersions-cell-one ${props.dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`} onClick={() => handleSelectVersion(props.dataItem)}>
                <div className={'gridHLPure-containerLabel'}>
                    {
                        ((props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC || props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_EXP)) ? (
                            <span className='gridHLPure-userName'>
                                {t('documentPanelBarVersions.main.version')}
                            </span>
                        ) : <span className='gridHLPure-userName'>
                            {t('documentPanelBarVersions.previous.version')}
                        </span>
                    }
                    <div className='gridHLPure-detailsContainer'>
                        <span className='gridHLPure-fieldSubtitle'>
                            {props.dataItem.date}
                        </span>
                    </div>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className={`documentPanelBarVersions-cell-two ${props.dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`} onClick={() => handleSelectVersion(props.dataItem)}>
                {
                    ((props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_VER_EXP || props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_VER_DOC) && !isInDeleteFlow) && (
                        <>
                            <div className={'cellActions-containerBtnsDetails'}>
                                <button
                                    className='cellActions-btn'
                                    onClick={() => handleMakeVersionMainDoc(props.dataItem)}
                                >
                                    <p className='cellActions-textBotton'>{t('documentPanelBarVersions.btn.actual')}</p>
                                </button>
                            </div>
                            <div className={'cellActions-containerBtnsDetails'}>
                                <Tooltip
                                    openDelay={600}
                                    position='top'
                                    anchorElement='target'
                                    tooltipClassName='tooltipGeneralStyle'
                                >
                                    <button
                                        className='cellActions-TrashBtn'
                                        onClick={() => handleShowVersionModal(props.dataItem)}
                                        data-id={'labelTrashActions'}
                                    >
                                        <i
                                            title={t('documentPanelBarVersions.delete.version')}
                                            className='k-icon k-i-delete k-i-trash'
                                        ></i>
                                    </button>
                                </Tooltip>
                            </div>
                        </>

                    )
                }
            </td>
        );
    };

    const heightGrid = 'var(--panelHeight)'

    const [showVersionModal, setVersionModal] = useState(false)
    const [versionSelected, setVersionSelected] = useState({})

    const handleShowVersionModal = (versionDoc) => {
        setVersionModal(true)
        setVersionSelected(versionDoc)
    }

    const handleCloseVersionModal = () => {
        setVersionModal(false)
    }

    const handleDeleteVersion = () => {
        setVersionModal(false)
        handleDeleteFileVersion(versionSelected.id)
    }

    return (
        <div className='documentPanelBarVersions-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('documentPanelBarVersions.versions.document')}
                className='documentPanelBarVersions'
                id='documentPanelBarVersions'
                actionComponent={props?.permissions?.version && (
                    <ButtonAddHLPure
                        nameBtn={t('documentPanelBarVersions.btn.add')}
                        onClickBtn={props.handleShowDialogVersion}
                        iconAdd
                        disabled={isInDeleteFlow}
                    />
                )}
            >
                <Grid item className='documentPanelBarVersions-grid-documents'>
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={'documentPanelBarVersions-general-grid'}
                        pageable={false}
                        skip={0}
                        take={versions.length}
                        dataGrid={versions}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t('documentPanelBarVersions.date')}
                        titleRow2={t('documentPanelBarVersions.action')}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={(showVersionsBtns) ? cellColumnTwo : null}
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>
            </PanelBarGLPure>
            {
                showVersionModal && (
                    <DialogSystemGLPure
                        showConfirm={showVersionModal}
                        confirmTitle={t('documentPanelBarVersions.title.modal')}
                        confirmMessage={t('documentPanelBarVersions.question.modal')}
                        handleConfirmDeleteFlowClose={handleCloseVersionModal}
                        handleConfirmDeleteFlowSubmit={handleDeleteVersion}
                        labelCancelConfirmation={t('button.cancel')}
                        labelSubmitConfirmation={t('button.delete')}
                    />
                )
            }
        </div>
    )
}

export { DocumentPanelBarVersions as default }